import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ExtrasContext = createContext(null);
const KEY = "ra_extras";

export function ExtrasProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
  });
  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* ignore */ }
  }, [items]);

  const add = useCallback((id) => setItems((p) => (p[id] ? p : { ...p, [id]: 1 })), []);
  const inc = useCallback((id) => setItems((p) => ({ ...p, [id]: (p[id] || 0) + 1 })), []);
  const dec = useCallback((id) => setItems((p) => {
    const q = (p[id] || 0) - 1; const n = { ...p };
    if (q <= 0) delete n[id]; else n[id] = q;
    return n;
  }), []);
  const remove = useCallback((id) => setItems((p) => { const n = { ...p }; delete n[id]; return n; }), []);
  const clear = useCallback(() => setItems({}), []);

  return (
    <ExtrasContext.Provider value={{ items, add, inc, dec, remove, clear }}>
      {children}
    </ExtrasContext.Provider>
  );
}

export const useExtras = () => useContext(ExtrasContext);
